export default "__VITE_ASSET__26a20fb9__"